module.exports = __webpack_public_path__ + "img/edge_hiver_hiver.5fc6c11d.svg";